import React, { useState, useEffect, useRef } from "react"
import CustomLink from "./CustomLink"
import { setNonDispalyValue } from "./EventHandler"

const MaterialsAndCompositions = (props) => {
   const [changeOccure, setChangeOccure] = useState(false)
   const [partName] = useState(props.partName)


   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name);
         }, 1000); // Add a 1-second delay
   
         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay);
      }
   }, [changeOccure, props.name, props.handleDiffCategory]);

   let firstTable = true

   const [currData, setData] = useState();
   const [previousData, setPreviousData] = useState();

   useEffect(() => {
      if (props.data) {
         setData(props.data);
      }
      if (props.previousData) {
         setPreviousData(props.previousData);
      }
   }, [props.data, props.previousData]);

   const containerRef = useRef(null)
   const table1Ref = useRef(null)
   const table2Ref = useRef(null)

   const calculateMaxHeights = () => {
      const table1Rows = table1Ref.current?.querySelectorAll("tr") || []
      const table2Rows = table2Ref.current?.querySelectorAll("tr") || []

      const rowCount = Math.min(table1Rows.length, table2Rows.length)
      const maxHeights = []

      for (let i = 0; i < rowCount; i++) {
         const table1Row = table1Rows[i]
         const table2Row = table2Rows[i]

         if (table1Row && table2Row) {
            const table1Height = table1Row.offsetHeight || 0
            const table2Height = table2Row.offsetHeight || 0
            maxHeights.push(Math.max(table1Height, table2Height))
         }
      }

      return maxHeights
   }

   let height = calculateMaxHeights()

   useEffect(() => {
      let isSyncing = false

      const handleScrollTable1 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop || 0
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const handleScrollTable2 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table1Ref.current) {
            table1Ref.current.scrollTop = table2Ref.current.scrollTop || 0
            table1Ref.current.scrollLeft = table2Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const table1 = table1Ref.current
      const table2 = table2Ref.current

      if (table1) {
         table1.addEventListener("scroll", handleScrollTable1)
      }

      if (table2) {
         table2.addEventListener("scroll", handleScrollTable2)
      }

      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScrollTable1)
         }
         if (table2) {
            table2.removeEventListener("scroll", handleScrollTable2)
         }
      }
   }, [])
   const compareObjects = (current, previous, parentKey = "") => {
      let differences = {}

      if (
         typeof current === "object" &&
         current !== null &&
         typeof previous === "object" &&
         previous !== null
      ) {
         // If both are objects, compare their keys recursively
         const keys = new Set([...Object.keys(current), ...Object.keys(previous)])
         keys.forEach((key) => {
            const newKey = parentKey ? `${parentKey}.${key}` : key // Flatten the key
            Object.assign(
               differences,
               compareObjects(current[key], previous[key], newKey)
            )
         })
      } else {
         // For primitive values, compare directly
         const flattenedKey = parentKey
         differences[flattenedKey] = current === previous ? "same" : "different"
      }

      return differences
   }

   const compareNodesRecursively = (currNode, currData, previousData) => {
      let differences = {}

      // Find the index of the current node in currData
      const currNodeIndex = currData.indexOf(currNode)

      // Get the node at the same index in previousData
      const previousNode = previousData[currNodeIndex]

      // Compare only if the previousNode exists
      if (previousNode) {
         if(!emptyObjectWithParentName(currNode) && !emptyObjectWithParentName(previousNode)){
            differences = compareObjects(currNode, previousNode)
         }
      }

      return differences
   }

   const getHeader = () => {
      var keys = getKeys()
      return keys.map((key, index) => {
         if (setNonDispalyValue(key)) {
            return null
         }
         return (
            <th key={key}>
               <span>{key}</span>
            </th>
         )
      })
   }

   const getRowsData = (data, value) => {
      const items = data
      const rootNodes = items.filter((node) => node.parentName === "")
      const keys = getKeys()

      return rootNodes.map((node) => {
         let differences
         let backgroundColor = ""
         if (value) {
            differences = compareNodesRecursively(node, currData, previousData)
         } else {
            differences = compareNodesRecursively(node, previousData, currData)
         }

         if (Object.values(differences).includes("different")) {
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            backgroundColor = "#ffcccc"
         } else {
            backgroundColor = "white"
         }
         let emptyObject = emptyObjectWithParentName(node)

         if (emptyObject) {
            // Render an empty row
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
               <tr style={{ borderBottom: "1px solid grey", height: Math.max(...height.slice(1))}}>
                  <td colSpan={keys.length} style={{ backgroundColor: "#ffcccc" }}></td>
               </tr>
            )
         }
         
         return (
            <RenderRow
               node={node}
               keys={keys}
               items={items}
               differences={differences}
               value={value}
               backgroundColor={backgroundColor}
               emptyObject={emptyObject}
            />
         )
      })
   }

   const getKeys = function () {
      return Object.keys(currData[0])
   }

   const getColumnKeys = function (columKeyInfo) {
      return Object.keys(columKeyInfo)
   }

   const RenderColumn = function (props) {
      return props.keys.map((key, index) => {
         if (props.data[key] != null) {
            return (
               <div key={index}>
                  {!props.emptyObject && (
                     <>
                        <span className={props.isbold ? "bomFontClass" : ""}>
                           {key}:{" "}
                        </span>{" "}
                     </>
                  )}
                  <span
                     style={{
                        fontWeight:
                           props.childKeysWithStatus[key] === "different" ? "bold" : "",
                        color:
                           props.childKeysWithStatus[key] === "different" ? "red" : "",
                     }}
                  >
                     {props.data[key]}
                  </span>
               </div>
            )
         } else return null
      })
   }

   const RenderLinkColumn = function (props) {
      return props.keys.map((key, index) => {
         if (
            props.data[key] &&
            key.toLowerCase() === "n" &&
            props.id &&
            props.id.toLowerCase().trim() !== "no access"
         ) {
            let name = props.data[key]
            let link = props.data["link"]
            let color = ""
            if (props.childKeysWithStatus) {
               if (props.childKeysWithStatus[key] === "different") {
                  color = "red"
               }
            }

            return (
               <div key={index} style={{ minWidth: "9rem" }}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>
                     {link ? (
                        <CustomLink id={props.id} link={link} name={name} color={color} />
                     ) : (
                        <span>{name}</span>
                     )}
                  </span>
               </div>
            )
         } else if (setNonDispalyValue(key)) {
            return null
         } else if (props.data[key] != null)
            return (
               <div key={index}>
                  {!props.emptyObject && (
                     <>
                        <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                     </>
                  )}
                  <span
                     style={{
                        color:
                           props.childKeysWithStatus[key] === "different" ? "red" : "",
                        fontWeight:
                           props.childKeysWithStatus[key] === "different" ? "bold" : "",
                     }}
                  >
                     {props.data[key]}
                  </span>
               </div>
            )
         else return null
      })
   }

   const emptyObjectWithParentName = (obj) => {
      return Object.keys(obj).every((key) => {
         if (key === "parentName") {
            return true // Skip checking 'parentName'
         }
         const value = obj[key]
         if (typeof value === "object" && value !== null) {
            // Recursively check nested objects
            return Object.values(value).every((subValue) => !subValue)
         }
         return !value // Check if the value is empty or falsy
      })
   }

   const RenderRow = ({
      node,
      keys,
      i = 0,
      countMinus = 0,
      countPlus = 0,
      root = true,
      items,
      differences,
      value,
      backgroundColor,
      emptyObject,
   }) => {
      const [childData, setChildData] = useState({
         expand: root ? true : false,
         countMinus: countMinus,
         countPlus: countPlus,
      })

      let childNodes = []
      childNodes = items.filter(
         (child) =>
            child.parentName === node["names"] && node["parentName"] !== node["names"]
      )

      const handleRootClick = () => {
         setChildData((data) => ({
            ...data,
            expand: !childData.expand,
            countMinus: 0,
         }))
      }

      const handleClick = () => {
         setChildData((data) => ({
            ...data,
            expand: !childData.expand,
         }))
      }
      var colKeys = []
      
      return (
         <>
            <tr
               key={i}
               style={{
                  borderBottom: "1px solid grey",
                  height: Math.max(...height.slice(1)),
                  backgroundColor: backgroundColor,
               }}
            >
               {keys.map((key, index) => {
                  if (
                     node[key] != null &&
                     typeof node[key] == "object" &&
                     key === "Name(N) Type(T)"
                  ) {
                     colKeys = getColumnKeys(node[key])
                     const childKeysWithStatus = Object.keys(differences || {})
                        .filter((diffKey) => diffKey.startsWith(`${key}.`)) // Match keys that start with the parent key
                        .reduce((acc, diffKey) => {
                           const childKey = diffKey.split(".").pop() // Extract the child key
                           acc[childKey] = differences[diffKey] // Map child key to its status
                           return acc
                        }, {})
                     return (
                        <td
                           key={index}
                           onClick={root ? handleRootClick : handleClick}
                           style={{ display: "flex", width: "max-content" }}
                        >
                           <div>
                              {childNodes.length > 0 ? (
                                 childData.expand ? (
                                    <i
                                       style={{ marginLeft: childData.countMinus }}
                                       className="fa fa-minus designParamPlus"
                                       aria-hidden="true"
                                    ></i>
                                 ) : (
                                    <i
                                       style={{ marginLeft: childData.countPlus }}
                                       className="fa fa-plus designParamPlus"
                                       aria-hidden="true"
                                    ></i>
                                 )
                              ) : (
                                 <span
                                    style={{ marginLeft: childData.countMinus + 30 }}
                                 ></span>
                              )}
                           </div>
                           <div>
                              <RenderLinkColumn
                                 isbold={true}
                                 id={node["id"]}
                                 data={node[key]}
                                 keys={colKeys}
                                 childKeysWithStatus={childKeysWithStatus}
                                 emptyObject={emptyObject}
                              />
                           </div>
                        </td>
                     )
                  } else if (
                     key.toLowerCase() === "name" 
                     // &&
                     // node["id"] &&
                     // node["id"].toLowerCase().trim() !== "no access"
                  ) {
                     var name = node[key]
                     return (
                        <td
                           style={{ display: "flex", width: "max-content" }}
                           key={index}
                           onClick={root ? handleRootClick : handleClick}
                        >
                           {childNodes.length > 0 ? (
                              childData.expand ? (
                                 <i
                                    style={{ marginLeft: childData.countMinus }}
                                    className="fa fa-minus designParamPlus"
                                    aria-hidden="true"
                                 ></i>
                              ) : (
                                 <i
                                    style={{ marginLeft: childData.countPlus }}
                                    className="fa fa-plus designParamPlus"
                                    aria-hidden="true"
                                 ></i>
                              )
                           ) : (
                              <span
                                 style={{ marginLeft: childData.countMinus + 22 }}
                              ></span>
                           )}
                           {node["link"] != null && node["link"] !== "" ? (
                              <CustomLink
                                 id={node["id"]}
                                 link={node["link"]}
                                 name={name}
                              />
                           ) : (
                              <span>{name}</span>
                           )}
                        </td>
                     )
                  }
                  if (node[key] != null && typeof node[key] == "object") {
                     colKeys = getColumnKeys(node[key])
                     const childKeysWithStatus = Object.keys(differences || {})
                        .filter((diffKey) => diffKey.startsWith(`${key}.`)) // Match keys that start with the parent key
                        .reduce((acc, diffKey) => {
                           const childKey = diffKey.split(".").pop() // Extract the child key
                           acc[childKey] = differences[diffKey] // Map child key to its status
                           return acc
                        }, {})
                     return (
                        <td key={index}>
                           <RenderColumn
                              isbold={true}
                              data={node[key]}
                              keys={colKeys}
                              childKeysWithStatus={childKeysWithStatus}
                              emptyObject={emptyObject}
                           />
                        </td>
                     )
                  } else if (setNonDispalyValue(key)) {
                     return null
                  } else {
                     if (differences) {
                        if (differences[key] === "different") {
                           return (
                              <td
                                 key={index}
                                 style={{ color: "red", fontWeight: "bold" }}
                              >
                                 {node[key]}
                              </td>
                           )
                        }
                     }
                     return <td key={index}>{node[key]}</td>
                  }
               })}
            </tr>
            {childData.expand &&
               value &&
               childNodes.map((child, index) => {
                  const childDifferences = compareNodesRecursively(
                     child,
                     currData,
                     previousData
                  )

                  let emptyObject = emptyObjectWithParentName(child)
                  if (
                     Object.values(childDifferences).includes("different") ||
                     emptyObjectWithParentName(child)
                  ) {
                     backgroundColor = "#ffcccc"
                  } else {
                     backgroundColor = "white"
                  }

                  return (
                     <RenderRow
                        node={child}
                        keys={keys}
                        index={index}
                        countMinus={childData.countMinus + 15}
                        countPlus={childData.countPlus + 15}
                        root={false}
                        items={items}
                        differences={childDifferences}
                        value={value}
                        backgroundColor={backgroundColor}
                        emptyObject={emptyObject}
                     />
                  )
               })}

            {childData.expand &&
               !value &&
               childNodes.map((child, index) => {
                  const childDifferences = compareNodesRecursively(
                     child,
                     previousData,
                     currData
                  )

                  let emptyObject = emptyObjectWithParentName(child)
                  if (
                     Object.values(childDifferences).includes("different") ||
                     emptyObjectWithParentName(child)
                  ) {
                     backgroundColor = "#ffcccc"
                  } else {
                     backgroundColor = "white"
                  }

                  return (
                     <RenderRow
                        node={child}
                        keys={keys}
                        index={index}
                        countMinus={childData.countMinus + 15}
                        countPlus={childData.countPlus + 15}
                        root={false}
                        items={items}
                        differences={childDifferences}
                        value={value}
                        backgroundColor={backgroundColor}
                        emptyObject={emptyObject}
                     />
                  )
               })}
         </>
      )
   }

   return (
      <div ref={containerRef} style={{ display: "flex" }}>
         <div
            ref={table1Ref}
            style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
         >
            {props.revision && props.revision !== "" && (
               <div
                  style={{
                     position: "sticky",
                     top: "0",
                     backgroundColor: "#EEEEEE",
                     textAlign: "center",
                     fontWeight: "bold",
                  }}
               >
                  {partName}{" "}{props.revision["releaseRevision"]}
               </div>
            )}
            {currData && currData.length > 0 && (
               <table className="tableBorder">
                  <thead
                     style={{
                        visibility: props.isHeader !== "false" ? "visible" : "collapse",
                     }}
                  >
                     <tr style={{ height: Math.max(...height) }}>{getHeader()}</tr>
                  </thead>
                  <tbody>{getRowsData(currData, firstTable)}</tbody>
               </table>
            )}
         </div>

         <div
            ref={table2Ref}
            style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
         >
            {props.revision && props.revision !== "" && (
               <div
                  style={{
                     position: "sticky",
                     top: "0",
                     backgroundColor: "#EEEEEE",
                     textAlign: "center",
                     fontWeight: "bold",
                  }}
               >
                  {partName}{" "}{props.revision["obsoleteRevision"]}
               </div>
            )}
            {previousData && previousData.length > 0 && (
               <table className="tableBorder">
                  <thead
                     style={{
                        visibility: props.isHeader !== "false" ? "visible" : "collapse",
                     }}
                  >
                     <tr style={{ height: Math.max(...height) }}>{getHeader()}</tr>
                  </thead>
                  <tbody>{getRowsData(previousData, (firstTable = false))}</tbody>
               </table>
            )}
         </div>
      </div>
   )
}
export default MaterialsAndCompositions
